// src/pages/painel/EditarPeso.js
import React, { useState } from 'react';
import './editarpeso.css';

const API_BASE = process.env.REACT_APP_API_BASE;

/**
 * Props esperadas:
 * - pesoAtual: número atual mostrado no painel
 * - setPesoAtual: setState vindo do Painel (atualiza o estado global)
 * - onClose: função para fechar o modal
 */
const EditarPeso = ({ pesoAtual, setPesoAtual, onClose }) => {
  const [novoPeso, setNovoPeso] = useState(
    pesoAtual ? String(pesoAtual).replace('.', ',') : ''
  );
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);

  const handleSalvar = async () => {
    setErro('');

    const pesoNumber = parseFloat(String(novoPeso).replace(',', '.'));
    if (isNaN(pesoNumber) || pesoNumber <= 0) {
      setErro('Digite um peso válido.');
      return;
    }

    setEnviando(true);

    try {
      const response = await fetch(`${API_BASE}/editar-peso.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ peso: pesoNumber }),
      });

      const data = await response.json();

      if (data.status === 'sucesso') {
        // Atualiza no Painel
        if (typeof setPesoAtual === 'function') {
          setPesoAtual(pesoNumber);
        }
        // Fecha modal
        onClose();
      } else {
        setErro(data.mensagem || 'Erro ao salvar peso.');
      }
    } catch (error) {
      setErro('Erro de conexão com o servidor.');
    } finally {
      setEnviando(false);
    }
  };

  const fecharAoClicarFora = (e) => {
    // Garante que só fecha se clicar no fundo escuro
    if (e.target.classList.contains('editarpeso-overlay')) {
      onClose();
    }
  };

  return (
    <div className="editarpeso-overlay" onClick={fecharAoClicarFora}>
      <div className="editarpeso-modal">
        {/* Botão X no canto superior direito */}
        <button
          type="button"
          className="editarpeso-fechar"
          onClick={onClose}
          aria-label="Fechar"
        >
          ×
        </button>

        <h2 className="editarpeso-titulo">Editar Peso Atual</h2>

        {typeof pesoAtual === 'number' && (
          <p className="editarpeso-peso-atual">
            Peso atual: <strong>{pesoAtual} kg</strong>
          </p>
        )}

        <label className="editarpeso-label">
          Novo peso (kg)
          <input
            type="number"
            step="0.1"
            placeholder="Digite seu novo peso (kg)"
            value={novoPeso}
            onChange={(e) => setNovoPeso(e.target.value)}
            className="editarpeso-input"
          />
        </label>

        {erro && <p className="editarpeso-erro">{erro}</p>}

        <div className="editarpeso-botoes">
          <button
            type="button"
            className="editarpeso-botao cancelar"
            onClick={onClose}
            disabled={enviando}
          >
            Cancelar
          </button>

          <button
            type="button"
            className="editarpeso-botao confirmar"
            onClick={handleSalvar}
            disabled={enviando}
          >
            {enviando ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditarPeso;
